module.exports = __webpack_public_path__ + "img/drill3_7-7-2021.02b4868b.jpg";